export default "__VITE_ASSET__a3ZCBGdP__"